export function actionSetStatuses(value) {
    return {
        type: 'SET_STATUSES',
        value: value
    };
}
